export const getGroupedOffers = (paymentOffers, groups) => {
	const grouped = {};
	paymentOffers.forEach((offer) => {
		if (!grouped[offer.type]) {
			grouped[offer.type] = [];
		}
		grouped[offer.type].push(offer);
	});
	return Object.keys(grouped).map(type => {
		const offers = grouped[type];
		const minPriceOffer = offers.reduce((min, curr) => (curr.amount < min.amount ? curr : min), offers[0]);
		const selectedGroup = groups.find(group => group.type === minPriceOffer.type);
		return {
			type,
			title:             window.$Helpers.getTranslatedContent(selectedGroup?.title) || '',
			info:              window.$Helpers.getTranslatedContent(selectedGroup?.info) || '',
			minPrice:          minPriceOffer.amount,
			minPriceFormatted: (minPriceOffer.amount / 100).toFixed(2),
			currencyCode:      minPriceOffer.currencyCode,
			features:          (selectedGroup?.features || []).map(feature => ({
				label: window.$Helpers.getTranslatedContent(feature.label),
				icon:  feature.icon,
			})),
		};
	});
};
